import { useNuxtApp } from '#app';
import { BaseService } from '../base/base.service';
import type { IModelResponse } from '../base/dto/base.dto';
import { ReportRepository } from './report.repository';

export class ReportService extends BaseService {
  private reportRepository = new ReportRepository(this.api, this.configService);

  async getReportList(params: any): Promise<IModelResponse<any>> {
    let dataResult: IModelResponse<any> = {
      data: {},
    };
    const { $functions } = useNuxtApp();
    try {
      const res = await this.reportRepository.getReportList(params);
      const resData = res.data.value;
      if (resData) {
        // Response is the file data directly (fileName, fileData)
        dataResult.data = resData.data || resData || {};
        dataResult.totalItems = resData.totalItems;
        console.log('getReportList response:', resData, 'dataResult:', dataResult);
      }
    }
    catch (err: any) {
      $functions.notify.error({
        text: err.message,
        isError: true,
      });
      console.log(err, ReportService.name);
    }
    return dataResult;
  }
  
  
  async getUsageReportList(params: any): Promise<IModelResponse<any>> {
    let dataResult: IModelResponse<any> = {
      data: {},
    };
    const { $functions } = useNuxtApp();
    try {
      const res = await this.reportRepository.getUsageReportList(params);
      const resData = res.data.value;
      if (resData) {
        // Response is the file data directly (fileName, fileData)
        dataResult.data = resData.data || resData || {};
        dataResult.totalItems = resData.totalItems;
        console.log('getUsageReportList response:', resData, 'dataResult:', dataResult);
      }
    }
    catch (err: any) {
      $functions.notify.error({
        text: err.message,
        isError: true,
      });
      console.log(err, ReportService.name);
    }
    return dataResult;
  }

  // Response is JSON rows ({ total, rows }), not a file; the page builds the export.
  // data stays null on failure (useApi already shows the error toast, e.g. 403 for non-admins).
  async getChatHistoryReport(params: any): Promise<IModelResponse<any>> {
    let dataResult: IModelResponse<any> = {
      data: null,
    };
    const { $functions } = useNuxtApp();
    try {
      const res = await this.reportRepository.getChatHistoryReport(params);
      const resData = res.data.value;
      if (resData) {
        dataResult.data = resData.data || null;
      }
    }
    catch (err: any) {
      $functions.notify.error({
        text: err.message,
        isError: true,
      });
      console.log(err, ReportService.name);
    }
    return dataResult;
  }
}

